import { api, signalr, auth } from '@/f1/service';
import RuleMethod from '../Rule.Method.i18n'
import LogDetail from '../../log/Log.Detail.i18n'
import LogList from '../../log/Log.List.i18n'
import _ from 'lodash'
// import reg from '@/f1/reg'
import AgentList from '../Agent.List.i18n';
import punycode from 'punycode'
import codes from '@/f1/codes'
import { VclFacebook } from 'vue-content-loading';
import moment from 'moment-timezone'
import Bell from 'vue-notification-bell'
import { Switch as cSwitch } from '@coreui/vue'
import VueApexCharts from 'vue-apexcharts'
import agent from '../service'
import FolderSet from '../FolderSet.i18n';
import 'flag-icon-css/css/flag-icon.css';

// 2022.07 신규
import RuleQuickSetup from '../Agent.Quick.i18n'
import RuleCRS from '../Agent.CRS.i18n'
import BarChart from '../../../report/chart/BarChart';
import RuleCustom from '../Rule.Custom.v2.i18n'
import RuleCountry from '../Agent.Country.i18n'
import Language from './language'
import Multiselect from 'vue-multiselect'

//restful api
import { webcastle_v2 as wc } from '@/f1/service/api';

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';


// const _changed_fields = {
//   EN : [
//     { key : 'key', label: 'PolicyID', thStyle: 'width: 10%' },
//     { key : 'desc', label: 'Message', },
//     { key : 'level', label: 'Level', thStyle: 'width: 10%' },
//     { key : 'severity', label: 'Risk', thStyle: 'width: 10%' },
//     { key: 'use', label: 'Status', thStyle: 'width: 15%' },
//     { key: 'mode', label: 'Mode', thStyle: 'width: 15%' },
//   ],
//   KO : [
//     { key : 'key', label: '정책ID', thStyle: 'width: 10%' },
//     { key : 'desc', label: '정책명', },
//     { key : 'level', label: '레벨', thStyle: 'width: 10%' },
//     { key : 'severity', label: '위험도', thStyle: 'width: 10%' },
//     { key: 'use', label: '상태', thStyle: 'width: 15%' },
//     { key: 'mode', label: '모드', thStyle: 'width: 15%' },
//   ]
// }


const default_setting = () => ({ limit_mode: false, limit_cpu: 90, limit_ram: 90, limit_disk: 90, resolve_cpu: 60, resolve_ram: 60, resolve_disk: 60, });

const default_policy = () => {
  return {
    level : 1, // 현재 레벨 사용 안함
    domain : 'default',
    country_code : [],
    use_geoip : false,
    custom_crs : [],

    // 사용자 정책
    redirection : '',
    custom_policy : '',

    // TODO : api 보안
    // use_method : false,
    // method_control : [{ policy_id : 1000, level : 1, mode: 1, severity : 6 }],

    // custom
    host_list : [],
    ip_list : [],
    parameter : [],
    path : [],

    // origin
    use_geoip_origin : false,
    redirection_origin : '',
    custom_crs_dic : {},

    // limit
    limit : {
      request_body_limit : 13107200,
      request_body_limit_no_file : 131072,
      response_body_limit : 524288,
      mime_type : [ "text/plain", "text/html", "text/xml" ],

    },
    is_alive : true, // 다른 도메인이 있을 경우 비활성화 가능
  }
}


export default {
  props: ['is_one', 'agent_list'],
  components: { Multiselect, Language, RuleCRS, BarChart, RuleCountry, AgentList, RuleQuickSetup, RuleCustom, VclFacebook, Bell, LogDetail, cSwitch, FolderSet, RuleMethod, LogList, VueApexCharts },
  data: () => {
    return {
      crs_count_preview : false,
      tab_index : 0, // 사용자 새로고침 기억용
      codes,
      // signalr,
      toggle : {
        modal_log : false,
        chart : false,
        modal_domain_manage : false,
        modal_del : false,
      },
      target_crs_rule : { id : 0, version : '', agent_version : '-' }, // 변경될 CRS 정책 메타 데이터
      crs_rule : { id : 1, version : '', agent_version : '-' }, // 현재 사용중인 변경될 CRS 정책 메타 데이터
      server : { policy_json : { domains : [] }, id : 0 },
      agent_setting : default_setting(),
      base_policy : {
        request : [],
        response : [],
        process : [],
        exclusion : [],
      },

      now_policy : default_policy(),
      crs_version_list : [],
      default_policy_crs : [],

      custom_policy : '',
      search_key : '', // 정책 검색 키
      latest_policy_version : '',
      del_nickname : '',
      new_domain : '',

      is_add_domain_lock : false,

      // 정책 업로드 관련
      upload_policy_selected : [],
      upload_policy_data : { domains : [] },
      upload_policy_file : undefined,
      modal_upload_policy : false,

      // 정책 알림 관련
      webcastle_alert : false,
      webcastle_alert_is_error : false,
      webcastle_alert_msg : '',

      domain_manage_fields : [
        { key : 'domain', label: 'Domain', thStyle: 'width: 65%' },
        // { key : 'status', label: 'Status' },
        // { key : 'mode', label: 'Mode' },
        // { key : 'level', label: 'Policy Security Level' },
        { key: 'button', label: 'Action' },
      ],

      // 차트 등 리소스 정보
      ping_th : undefined,
      info : {
        is_online : false,
        status : {
          system_cpu_info : {},
          system_disk_info : {}
        },
        chart : {
          policy : {
            // colors:['#339BFB' ],
            title : { text: '', align : 'center', show : false},
            series : [],
            option : {
              colors : [codes.WAF_MODE_TO_COLOR(0, 'hex'), codes.WAF_MODE_TO_COLOR(1, 'hex'), codes.WAF_MODE_TO_COLOR(2, 'hex')],
              labels : [],
              legend: {
                position : 'bottom',
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial',
                fontWeight: 400,
                itemMargin: {
                  vertical: 10
                },
                formatter: function(seriesName, opts) {
                  return '<div class="legend-info">' + '<span>' + seriesName + '</span>' + '<span> (' + opts.w.globals.series[opts.seriesIndex] + ') </span>' + '</div>'
                }
              },
              dataLabels: {
                enabled: false,
              },
              plotOptions : {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        show: true,
                        fontSize: '1.2rem',
                        fontFamily: 'Rubik',
                        color: '#dfsda',
                        offsetY: -4
                      },
                      value: {
                        show: true,
                        fontSize: '1.2rem',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        color: undefined,
                        offsetY: -0,
                        formatter: function (val) {
                          return val
                        }
                      },
                      total: {
                        show: true,
                        label: 'Total',
                        fontSize: '1.0rem',
                        color: '#373d3f',
                        formatter: function (w) {
                          return w.globals.seriesTotals.reduce((a, b) => {
                            return a + b
                          }, 0)
                        }
                      }
                    }
                  }
                }
              }
            },
          },
          color : {
            NORMAL : '#339BFB',
            WARNING : '#FFC90E',
            DANGER : '#F44336',
          },
          memory : { colors:['#339BFB' ], title : { text: 'Memory (%)', align : 'left'}, series : [], yaxis : { tickAmount : 5, show : false, min : 0, max : 100 }, xaxis : { categories : [] } },
          cpu : { colors:['#339BFB' ], title : { text: 'CPU (%)', align : 'left' }, series : [], yaxis : { tickAmount : 5, show : false, min : 0, max : 100 }, xaxis : { categories : [] } },
          workload : { stroke: { width: 0 }, dataLabels: { enabled: true }, plotOptions : {
            legend : { show : false },
            heatmap : {
              radius: 15,
              enableShades: false,
              colorScale: { ranges: [{ from: 0, to: 33, color: '#339BFB', name : "low" }, { from: 34, to: 66, color: '#FFC90E', name : "normal" }, { from: 67, to: 100, color: '#F44336', name : "high" }], }

            }
          }
          , title : { text: 'CPU workload (%)', align : 'left' }, series : [], yaxis : { labels : { show : false }, tickAmount : 5, show : false, min : 0, max : 100 }, xaxis : { show : false, labels : { show : false }, tickAmount : 1, categories : [] } },
        },
      },
      auth,

      // 정책 업그레이드 관련
      upgrade_policy_modal : false,
      upgrade_policy_from : {},
      upgrade_policy_to : {},

      // 로그 상세 모달 관련
      modal_log_id : 0,

      // 이름 수정 관련
      name_modify_modal : false,
      modify_name : '',

      // 기타
      webcastle_mmdb : '',
      modal_duplex : false,

      loading: true,
      explain_level : false,
      apply_modal : false,
      rule_confirm : false,
      status_confirm : false,
      change_main_policy : false,
      modal_domain_remove : false,
      is_require_save : false,
      is_available_mmdb_update : false,

      // 빠른 설정 관련
      quick_modal : false,
      quick_setting_status : false,
      is_first : false,

      // 다른 서버로 설정 복사 관련
      apply_all_server: [],
      apply_confirm_modal : false,
      summary : {},
    }
  },
  computed: {
    is_available_policy_request() { return (this.base_policy.request || []) ? _.filter(this.base_policy.request, x => x.is_available === true).length : 0 },
    is_available_policy_response() { return (this.base_policy.response || []) ? _.filter(this.base_policy.response, x => x.is_available === true).length : 0 },
    is_available_policy_process() { return (this.base_policy.process || []) ? _.filter(this.base_policy.process, x => x.is_available === true).length : 0 },
    is_available_policy_exclusion() { return (this.base_policy.exclusion || []) ? _.filter(this.base_policy.exclusion, x => x.is_available === true).length : 0 },

    is_require_save_style()  { return this.is_require_save },
    disckStatus() { return this.info.status && this.info.status.system_disk_info ? _.filter(this.info.status.system_disk_info.info, x => x.mountpoint && x.percent) : [] },
    crs_rule_count() { return _.filter((this.crs_version_list), x => x.id > this.crs_rule.id).length },
    fields() { return _i18n_data.i18n_fields[this.i18n]; },
  },
  methods: {
    toggle_crs_count_preview() {
      this.crs_count_preview = !this.crs_count_preview
      sessionStorage.setItem('crs_count_preview', this.crs_count_preview);
    },
    get_unsaved_preview_domain() {
      let origin = _.map(JSON.parse(this.server.policy).domains, x => x.domain)
      let domain_list = []

      for (let i = 0; i < this.server.policy_json.domains.length; i++) {
        if(this.server.policy_json.domains[i].is_save === false) {
          // 신규
          domain_list.push({ domain : this.server.policy_json.domains[i].domain, type : _i18n_data._i18n_info.add[this.i18n] })

          continue
        }

        // 삭제
        origin = _.filter(origin, d => d != this.server.policy_json.domains[i].domain)
      }

      return domain_list.concat(_.map(origin, d => { return { domain : d, type : i18n_data._i18n_success.deleted[this.i18n] } }))
    },
    check_change() {

      // 테스트용으로 당분간 사용, 코드 클린 업 필요
      let x1 = this.is_changed('redirection')
      console.log("this.is_changed('redirection')", x1)
      let x2 = this.is_changed('ip_list')
      console.log("this.is_changed('ip_list')", x2)
      let x3 = this.is_changed('host_list')
      console.log("this.is_changed('host_list')", x3)
      let x4 = this.is_changed('country_code')
      console.log("this.is_changed('country_code')", x4)
      let x5 = this.is_changed('parameter')
      console.log("this.is_changed('parameter')", x5)
      let x6 = this.is_changed('path')
      console.log("this.is_changed('path')", x6)
      let x7 = this.is_changed('use_geoip')
      console.log("this.is_changed('use_geoip')", x7)
      let x8 = this.is_changed('domain')
      console.log("this.is_changed('domain')", x8)
      let x9 = this.is_changed('custom_policy')
      console.log("this.is_changed('custom_policy')", x9)
      let x10 = this.is_changed('agent.setting')
      console.log("this.is_changed('agent.setting')", x10)
      let x11 = this.is_changed('limit')
      console.log("this.is_changed('limit')", x11)

      console.log('x1 || x2 || x3 || x4 || x5 || x6 || x7 || x8 || x9 || x10 || x11', x1, x2, x3, x4, x5, x6, x7, x8, x9, x10, x11)

      this.is_require_save = x1 || x2 || x3 || x4 || x5 || x6 || x7 || x8 || x9 || x10 || x11

    },
    is_changed(type='') {
      if(!type || !this.server.policy) { console.log('no have policy or type', type, this.now_policy.domain); return false }

      if(type == 'custom_policy') {
        return this.base64decode(this.now_policy.custom_policy.trim()) != this.custom_policy.trim()
      }


      let index = _.findIndex(JSON.parse(this.server.policy).domains, { domain : this.now_policy.domain })

      if(index < 0) {
        // 기존 설정에 도메인이 없을 경우

        index = _.findIndex(this.server.policy_json.domains, { domain : this.now_policy.domain })

        if(index < 0 || type != 'domain') {
          console.log('no have a domain', this.now_policy.domain, type)
          return false
        }

        console.log('findout domain into unsaved domain', type)

        return (this.server.policy_json.domains[index].is_save === undefined || this.server.policy_json.domains[index].is_save === false)

      } else if(type == 'domain') {
        // console.log('type is domain return', JSON.stringify(JSON.parse(this.server.policy).domains).length, JSON.stringify(this.server.policy_json.domains).length)
        return JSON.stringify(JSON.parse(this.server.policy).domains) != JSON.stringify(this.server.policy_json.domains)
      }

      if(type == 'custom_policy') {
        // 사용자 CRS 정책 추가
        return this.custom_policy != this.base64decode(JSON.parse(this.server.policy).domains[index][type])
      }

      if(type == 'agent.setting') {
        // 에이전트 설정 변경이 있을 경우, 현재는 리소스 제한 설정만 변경임
        return JSON.stringify(JSON.parse(this.server.setting)) != JSON.stringify(this.agent_setting)
      }



      // console.log(JSON.stringify(JSON.parse(this.server.policy).domains[index][type]).length, JSON.stringify(this.now_policy[type]).length)
      return (JSON.stringify(JSON.parse(this.server.policy).domains[index][type]) != JSON.stringify(this.now_policy[type]))
    },
    get_origin_policy(type='') {
      if(!type) { return alert(_i18n_data._i18n_alert.policy_check[this.i18n]) }
      let index = _.findIndex(JSON.parse(this.server.policy).domains, { domain : this.now_policy.domain })
      if(index < 0) {
        // 미저장 도메인
        index = _.findIndex(this.server.policy_json.domains, { domain : this.now_policy.domain })
        if(index< 0) { return alert(_i18n_data._i18n_alert.domain_check[this.i18n]) }

        return this.server.policy_json.domains[index][type]
      }

      return JSON.parse(this.server.policy).domains[index][type]
    },

    // 공통 저장 함수
    async save() {

      try {
        let temp = this.server.policy_json
        _.forEach(temp.domains, d => delete d.is_save)

        // JSON 만 넣기
        // let rs = await api.webcastle.WebCastle({ target : 'agent', cmd : 'update', body: Object.assign({}, this.server, { policy : JSON.stringify(temp) })});
        let rs = await wc.agent.update(Object.assign({}, this.server, { policy : JSON.stringify(temp) }));
        if(rs.error) {  return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }

        this.$toastr.s(i18n_data._i18n_success.saved[this.i18n || 'EN']);

        // input is agent, 비동기 처리
        this.reload(rs.body)

        this.$forceUpdate()

        return true
      } catch(e) {
        console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText, 'Save failed');
        return false
      }
    },
    // min required to internet explorer 10 over
    // util start
    base64encode(x) { return window.btoa(encodeURIComponent(x)) },
    base64decode(x) { return decodeURIComponent(window.atob(x)) },
    toggle_resource() { this.toggle.chart = !this.toggle.chart; this.wait_resource = this.toggle.chart ? true : this.wait_resource },
    get_url() { return `${location.protocol}//${location.host}` },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    crs_line_count(type='custom_rule') {
      if(type == 'custom_rule') {
        return this.now_policy.custom_rule && this.now_policy.custom_rule.length ? this.now_policy.custom_rule.split(/\r\n|\r|\n/).length + 3 : 3
      } else if(type == 'origin_custom_rule') {
        let index = _.findIndex(JSON.parse(this.server.policy).domains, { domain : this.now_policy.domain })
        if(index < 0) { return 3 }

        return (JSON.parse(this.server.policy).domains[index].custom_rule || '').split().length + 3
      }
      return 3
    },
    // util end

    // CRS 정책 상태 변경
    async save_policy_one(crs) {
      // 정책 대분류 한개 업데이트

      this.now_policy.custom_crs_dic[crs.key] = crs
      this.now_policy.custom_crs = Object.keys(this.now_policy.custom_crs_dic).map(x => this.now_policy.custom_crs_dic[x])

      // console.log(this.server.policy_json, this.now_policy.domain)
      let index = _.findIndex(this.server.policy_json.domains, { domain : this.now_policy.domain })
      if(index < 0) { return alert(_i18n_data._i18n_alert.domain_check_2[this.i18n]) }
      this.server.policy_json.domains[index] = this.now_policy

      // 저장 함수는 통합
      let is_clear = await this.save()
      if(is_clear) {
        this.refresh_custom_crs()
        // 성공했을 경우 임시 변수 삭제
        this.now_policy.custom_crs_dic[crs.key] = Object.assign({}, this.now_policy.custom_crs_dic[crs.key], { policy_list : _.map(this.now_policy.custom_crs_dic[crs.key].policy_list, x => {
           x.is_change = false
           delete x.severity_origin
           delete x.mode_origin
          //  delete x.level_origin // 향후 사용 가능
          //  console.log(x.key, x.is_change, x.severity, x.severity_origin)
           return x
         })
        })
      }
    },

    // 부가적인 설정 상태 변경
    async save_policy_option() {
      // 옵션 정책 전체 업데이트

      // 1. ip 주소 & 도메인 주소 관리 => 컴포넌트에서 처리 여기는 확인용
      console.log('ip_list', this.now_policy.ip_list)
      console.log('host_list', this.now_policy.host_list)

      // 2. 국가 필터링  => 컴포넌트에서 처리 여기는 확인용
      console.log('country', this.now_policy.country_code)

      // 3 경로 / 라미터
      console.log('path', this.now_policy.path)

      // 4. 자원 모니터링
      this.server.setting = JSON.stringify(this.agent_setting)

      if(this.agent_setting.limit_cpu < 0 || this.agent_setting.limit_cpu > 100) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.resolve_cpu < 0 || this.agent_setting.resolve_cpu > 100) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.limit_disk < 0 || this.agent_setting.limit_disk > 100) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.resolve_disk < 0 || this.agent_setting.resolve_disk > 100) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.limit_ram < 0 || this.agent_setting.limit_ram > 100) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.resolve_ram < 0 || this.agent_setting.resolve_ram > 100) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }

      if(this.agent_setting.resolve_cpu > this.agent_setting.limit_cpu) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.resolve_ram > this.agent_setting.limit_ram) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }
      if(this.agent_setting.resolve_disk > this.agent_setting.limit_disk) { return this.$toastr.e(this.i18n_data['value_error'][this.i18n]) }


      // 5. 사용자 정책
      this.now_policy.custom_policy = this.custom_policy.trim() ? this.base64encode(this.custom_policy.trim()) : ''
      if(this.now_policy.redirection && !this.now_policy.redirection.startsWith('http')) {
        return alert(_i18n_data._i18n_alert.URL_check[this.i18n])
      }

      // 6. 메소드 정책
      // TODO : 해야 함

      // 최종 빌드 및 저장
      // console.log(this.server.policy_json, this.now_policy.domain)
      let index = _.findIndex(this.server.policy_json.domains, { domain : this.now_policy.domain })
      if(index < 0) { return alert(_i18n_data._i18n_alert.domain_check_2[this.i18n]) }
      this.server.policy_json.domains[index] = Object.assign({}, this.now_policy, { custom_crs_dic : '' })

      let rs = await this.save()
      if(!rs) {
        // TODO : 저장 실패시 추가 조치가 필요
        // console.log('nee')
      }
    },
    // 신규 함수 작성
    // 아래는 하위 호환용

    // mmdb 업데이트 가능 여부 확인
    check_mmdb_available() {
      this.is_available_mmdb_update = false

      let version = this.server.mmdb_version.replace(/([\.|v])/gm, '').substring(0, 6)

      console.log('server.mmdb_version', version)

      if(!version) {
        this.is_available_mmdb_update = false
        console.log("incorrect mmdb_version version", version)
        return
      }

      let server_version = this.webcastle_mmdb.replace(/([\.|v])/gm, '').substring(0, 6)

      if(!server_version) {
        this.is_available_mmdb_update = false
        console.log("incorrect server_version", server_version)
        return
      }

      // return true
      // 개발 서버 이므로
      // 2021.11 버전 이거나 이상일 경우 mmdb 업데이트 가능
      this.is_available_mmdb_update = version < server_version
      // this.mmdb_latest = webcastle_mmdb

      // console.log(this.is_available_mmdb_update, version, server_version, 'this.mmdb_latest', this.mmdb_latest)

      return this.is_available_mmdb_update
    },

    // 업로드한 정책 저장
    // TODO : 작업 필요
    async upload_policy_save() {
      try {

        if(!this.upload_policy_selected || this.upload_policy_selected.length < 1) { return this.$toastr.w(`${i18n_data._i18n_warning.policy_check[this.i18n]}`) }

        this.loading = true
        let last_index = -1

        for (let l = 0; l < this.upload_policy_selected.length; l++) {
          const domain = this.upload_policy_selected[l];

          let index_target = _.findIndex(this.server.policy_json.domains, { domain : domain })
          let index_upload = _.findIndex(this.upload_policy_data.domains, { domain : domain })

          // 신규 생성
          if(index_target < 0) {
            this.server.policy_json.domains.push(this.upload_policy_data.domains[index_upload])

            console.log('domain', domain, 'new!!!', this.loading, this.server.policy_json.domains)

            last_index = this.server.policy_json.domains.length - 1
            continue
          }

          this.server.policy_json.domains[index_target] = Object.assign({}, this.upload_policy_data.domains[index_upload])

          last_index = index_target

          console.log('domain', domain, 'update', this.loading, this.server.policy_json.domains[index_target])

        }

        this.now_policy = Object.assign({}, this.server.policy_json.domains[last_index])

        this.now_policy['upload_domain'] = this.upload_policy_selected

        this.is_require_save = true

        this.$toastr.w(`${i18n_data._i18n_warning.policy_check_2[this.i18n]}`)

      } catch (e) {
        console.log(e)
        this.$toastr.e(`${i18n_data._i18n_error.policy_json[this.i18n]}`)
      }
      this.upload_policy_data =  { domains : [] }
      this.upload_policy_selected = []

      this.loading = false
    },

    // 정책 백업 파일 선택시 이벤트
    async upload_policy_change(evt) {
      try {
        // 1 개만 사용
        this.upload_policy_data =  { domains : [] }
        for (let i = 0; i < evt.target.files.length; i++) {
          const f = evt.target.files[i];
          let data = await new Response(f).json();
          this.upload_policy_data = Object.assign({}, this.upload_policy_data, data)
        }

        return
      } catch (error) {
        console.log(error)
        this.$toastr.e(`${i18n_data._i18n_error.policy_json[this.i18n]}`)
        this.upload_policy = false
      }
    },

    async download_policy() {

      let index = _.findIndex(this.server.policy_json, { domain : this.now_policy.domain })
      let policy = this.server.policy_json

      policy[index] = this.now_policy

      const blob = new Blob([JSON.stringify(policy)], { type: 'application/json' });
      const link = document.createElement('a');
      link.download = `${this.server.nickname}_${moment().format('YYYY_MM_DD')}.json`;
      link.href = await URL.createObjectURL(blob);
      link.click()
      link.remove();
      return
    },

    // mmdb 업데이트
    db_update_cmd() {
      try {
        agent.Cmd("mmdb_update", this.server.id)
        this.$toastr.i(`${i18n_data._i18n_info.request_update[this.i18n]}`)
        console.log('request to agent', this.server.nickname, 'mmdb_update')
      } catch (e) { console.long(e) }
    },

    // 도메인 변경
    change_domain(domain){
      try {
        console.log("new Policy", domain)
        if(!domain) { return this.$toastr.e(`${i18n_data._i18n_error.change_domain[this.i18n]}`) }

        let index = _.findIndex(this.server.policy_json.domains, { domain : domain } )
        if(index < 0) { return alert(_i18n_data._i18n_alert.domain_check_3[this.i18n]) }

        this.now_policy = Object.assign({}, this.server.policy_json.domains[index])

        this.now_policy.use_geoip_origin = this.now_policy.use_geoip;

        // 사용자 CRS 정책
        this.custom_policy = this.now_policy.custom_policy ? this.base64decode(this.now_policy.custom_policy) : ''
        // 에이전트 설정
        this.agent_setting = Object.assign({}, this.agent_setting, JSON.parse(this.server.setting))

        // 리다이렉션 처리
        this.now_policy.redirection_origin = this.now_policy.redirection;

        // 리다이렉션 처리
        this.now_policy.limit_origin = JSON.parse(JSON.stringify(this.now_policy.limit));

        // 사용자 CRS 정책
        if(this.now_policy.custom_policy) {
          try {
            this.custom_policy = this.base64decode(this.now_policy.custom_policy)
          } catch (e) {
            this.custom_policy = this.now_policy.custom_policy
            console.log(e)
          }
        } else {
          this.custom_policy = ''
        }

        this.now_policy.custom_crs_dic = {}

        this.refresh_custom_crs()

        this.$toastr.i(_i18n_data._i18n_info.domain[this.i18n])

      } catch (e) { console.log(e); this.$toastr.e(`${i18n_data._i18n_error.load_error_1[this.i18n]}`) }
    },

    // 이름 수정
    async name_modify() {
      try{
        if(!this.modify_name) { return this.$toastr.w(`${i18n_data._i18n_warning.name_modify[this.i18n]}`) }

        // let rs = await api.webcastle.WebCastle_Call('agent', 'update', Object.assign({}, this.server, { nickname : this.modify_name }));
        let rs = await wc.agent.update(Object.assign({}, this.server, { nickname : this.modify_name }));
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }

        this.name_modify_modal = false
        this.server.nickname = this.modify_name
        this.modify_name = '';

        this.$toastr.i(`${i18n_data._i18n_success.saved[this.i18n]}`)
      } catch(e) { console.log(e) }
    },

    // 목록으로
    list() {
      this.$parent.$emit('refresh')
      this.$router.push({ name: 'webcastle_agent'});
    },

    // TODO : 퀵 설정 저장 함수
    async save_policy_quick(now_policy='') {
      try {
        if(!now_policy) { return }
        // 최종 빌드 및 저장
        // console.log(this.server.policy_json, this.now_policy.domain)
        let index = _.findIndex(this.server.policy_json.domains, { domain : this.now_policy.domain })
        if(index < 0) { return alert(_i18n_data._i18n_alert.domain_check_2[this.i18n]) }
        this.now_policy = Object.assign({}, this.now_policy, now_policy)
        this.server.policy_json.domains[index] = Object.assign({}, this.now_policy, { custom_crs_dic : {} })

        // 퀵 설정으로 바로 사용 처리
        this.server.policy_json.status = true

        let rs = await this.save()
        if(!rs) {
          return alert(_i18n_data._i18n_alert.save_policy[this.i18n])
        }

        // 빠른 설정 끝
        this.quick_setting_status = false

        this.refresh_custom_crs()

      } catch (e) { console.error(e) }
    },

    // TODO : 다른 서버 저장 정책 함수
    // 다른 서버 적용 함수 시작
    // async multi_save() { // 설정 저장
    //   try{
    //     let policy_list = _.map(this.policy_list, r => _.find(this.server.policy_json.domains, { "domain" : r }))
    //     let body = { policy_list : policy_list, server_list : this.apply_all_server.map(r => r.id) }
    //     this.apply_all_server = []
    //     //let rs = await api.webcastle.WebCastle_Call('agent', 'update.policy', body);
    //     let rs = await wc.agent.policy(body);
    //     if(rs.error) { return this.$toastr.e("update failed") }
    //     this.$toastr.s('Apply to agents.');
    //     this.$emit('refresh');
    //     this.apply_confirm_modal = false
    //     this.apply_modal = false
    //   } catch(e) { this.catch_msg(e) }
    // },
    // multi_remove(index) { this.apply_all_server.length < 2 ? this.apply_all_server = [] : this.apply_all_server.splice(index, 1) },
    // multi_one(item) {
    //   try {
    //     if(item) {
    //       if(!item) { return 'no have a data' }
    //       // console.log(item, this.apply_all_server)
    //       if(item.is_del) {
    //         this.apply_all_server = this.apply_all_server.map(r => { if (r && r.id != item.id) { return r } }).filter( r => r != null)
    //       } else {
    //         this.apply_all_server.push(item)
    //       }
    //     }
    //   } catch (e) {
    //     console.log(e)
    //   }
    //  },
    // multi_all(items) { (items || []).map(r => { r && _.filter(this.apply_all_server, { nickname : r.nickname }).length < 1 ? this.apply_all_server.push(r) : '' }) },
    // multi_clear() { this.apply_all_server = [], console.log("clear") },

    // 다른 서버 적용 함수 끝
    async status_save(event, value) {
      try{

        this.server.policy = JSON.stringify(Object.assign({}, JSON.parse(this.server.policy), { status : value }))

        this.server.lock = true

        // let rs = await api.webcastle.WebCastle({ target:'agent', cmd:'update', body: this.server})
        let rs = await wc.agent.update(this.server);

        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }

        this.$toastr.s(this.i18n_data['saved'][this.i18n])

        // TODO : 업데이트 필요할 수 있음, 정책 동기화

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.save_failed[this.i18n]}`); }
      finally {
        this.server.lock = false
      }
    },
    async domain_manage_remove(domain = '') {
      // Domain remove
      try{
        if(!domain) { alert(_i18n_data._i18n_alert.domain_check_4[this.i18n]) }

        let domains = _.filter(this.server.policy_json.domains, d => d.domain != domain)
        this.server.policy_json = Object.assign({}, this.server.policy_json, { domains : domains })

        console.log('try change', domains.length - 1, this.server.policy_json.domains)

        this.now_policy = Object.assign({}, this.server.policy_json.domains[domains.length - 1], { custom_crs_dic : {} })

        this.refresh_custom_crs()

        if(this.now_policy.domain == 'default' && this.server.policy_json.domains.length < 2) {
          this.now_policy.is_alive = this.server.policy_json.domains[domains.length - 1].is_alive = true
        }


        this.check_change()

        console.log("now domain is ", this.now_policy.domain)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.error_code_2[this.i18n]}`); }
    },

    // 도메인 추가
    async domain_manage_regist(new_domain='', from='') {

      try {
        this.is_add_domain_lock = true

        // // const rs = await api.webcastle.WebCastle({target : 'agent', cmd : 'domain.limit', body : new Date().getTime()})
        // const rs = await wc.agent.domainLimit(new Date().getTime());
        // if(rs.error) { this.this.is_add_domain_lock = false; return this.$toastr.e("can't verify license") }

        // // 라이선스 확인
        // if(rs.body < this.server.policy_json.domains.length) { this.this.is_add_domain_lock = false; return this.$toastr.e("Number of domains exceeded! Please upgrade your license!")}

        if(from) {
          // 복사
          let target_domain = `${from}.${moment().valueOf()}`
          let index = _.findIndex(this.server.policy_json.domains, { domain : from } )
          if(index < 0) { return alert(_i18n_data._i18n_alert.domain_check_3[this.i18n]) }

          this.now_policy = Object.assign({}, JSON.parse(JSON.stringify(this.server.policy_json.domains[index])), { is_save : false, domain : target_domain, custom_crs_dic : {} })

          // 사용자 CRS 정책
          if(this.now_policy.custom_policy) {
            try {
              this.custom_policy = this.base64decode(this.now_policy.custom_policy)
            } catch (e) {
              this.custom_policy = this.now_policy.custom_policy
              console.log(e)
            }
          } else {
            this.custom_policy = ''
          }

          this.server.policy_json.domains.push(this.now_policy)

        } else {

          // 한글 도메인 등록
          let _new_domain = new_domain.trim().replace(/(http|https):\/\//g, '')
          if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(_new_domain)){ _new_domain = punycode.toASCII(_new_domain) }

          if(!_new_domain || _new_domain.replace(/ /g, '') != _new_domain) { return alert(_i18n_data._i18n_alert.domain_check_5[this.i18n]) }

          // 중복 검사
          let index = _.findIndex(this.server.policy_json.domains, { domain : _new_domain } )
          if(index > -1) { return alert(_i18n_data._i18n_alert.domain_check_6[this.i18n]) }

          // 도메인 신규 생성
          this.now_policy = Object.assign({}, default_policy(), { domain : _new_domain, is_save : false, custom_crs : this.default_policy_crs, custom_crs_dic : {} })
          this.server.policy_json.domains.push(this.now_policy)
        }

        this.reload_custom()

        this.refresh_custom_crs()

        this.new_domain = ''

        this.check_change()

      } catch (e) {
        console.log(e)
      } finally {
        this.is_add_domain_lock = false
      }

    },
    reload_custom() {
      // GEO 정책 업데이트
      this.now_policy.use_geoip_origin = this.now_policy.use_geoip;

      // 사용자 CRS 정책
      this.custom_policy = this.now_policy.custom_policy ? this.base64decode(this.now_policy.custom_policy) : ''
      // 에이전트 설정
      this.agent_setting = Object.assign({}, this.agent_setting, JSON.parse(this.server.setting))

      // 리다이렉션 처리
      this.now_policy.redirection_origin = this.now_policy.redirection;

      // 제한 처리
      this.now_policy.limit_origin = JSON.parse(JSON.stringify(this.now_policy.limit));
    },

    // 정책 변경
    // TODO : 작업 해야 함
    // async change_crs() {
    //   try {
    //     this.server.crs_id = this.target_crs_rule.id

    //     // 해당 에이전트 버전이 최소 버전보다 작을 경우 업데이트 불가 안내
    //     if(this.crs_rule.agent_version && this.target_crs_rule.agent_version && Number(this.crs_rule.agent_version.replace('.','')) < Number(this.target_crs_rule.agent_version.replace('.',''))) {
    //       return this.$toastr.e("Update Agent!, minimum version "+this.target_crs_rule.agent_version);
    //     }

    //     //let rs = await api.webcastle.WebCastle({ target : 'agent', cmd : 'update', body: this.server });
    //     let rs = await wc.agent.update(this.server);
    //     if(rs.error) { return this.$toastr.e("update failed") }

    //     this.$toastr.s( this.i18n_data['reload'][this.i18n]);

    //     this.loading = true
    //     this.change_main_policy = false

    //     setTimeout(() => location.reload(), 2000)

    //   } catch (e) { console.log(e); this.$toastr.e("load error #1") }
    // },

    // 최근 한달 정책 요약 받
    async get_policy_summary() {
      // 기본 정책 로딩
      try {
        // let rs_crs = await api.webcastle.WebCastle({ target : 'log', cmd : 'summary.policy', body : { id : this.server.id } });
        let rs_crs = await wc.detect.policy({ id : this.server.id });
        if(rs_crs.error) { return this.$toastr.e(`${_i18n_data._i18n_error.policy_failed[this.i18n]}`) }

        this.summary = Object.assign({}, ...(rs_crs.body || []).map((x) => ({[x[0]]: x[1]})));

        console.log('this.summary', this.summary)
      } catch (e) { console.log(e); this.$toastr.e(`${_i18n_data._i18n_error.policy_failed_2[this.i18n]}`) }
    },

    // CRS 최신 정책 받기
    async get_policy_version() {
      // 기본 정책 로딩
      try {
        // let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'version', body : { id : this.server.crs_id } });
        let rs_crs = await wc.policy.version({ id : this.server.crs_id });
        if(rs_crs.error) { return this.$toastr.e(`${i18n_data._i18n_error.policy_failed[this.i18n]}`) }
        this.crs_version_list = rs_crs.body

        let latest =  _.maxBy(_.filter(this.crs_version_list, v => v.id > this.crs_rule.id), x => x.id)
        this.latest_policy_version = latest ? latest.version : ''

      } catch (e) { console.log(e); this.$toastr.e(`${_i18n_data._i18n_error.policy_version[this.i18n]}`) }
    },

    // mmdb 최신 버전 받기
    async get_mmdb_version() {
      try {
        let is_dev = location.hostname == 'localhost' || location.hostname.replace('console.', '').startsWith('f1secaas.co.kr') || location.hostname.replace('console.', '').startsWith('f1secaas.net')
        //Todo : 해당 api 는 현재 v1 을 쓰고 있으며 v2 로 바꿀시 어디까지 영향이 있는지 알 수 없어 일단 보류됨.
        // let rs = await api.webcastle.WebCastleDBLatest(is_dev ? 'develop' : 'release')
        let rs = await wc.WebCastleDBLatest(is_dev ? 'develop' : 'release')
        this.webcastle_mmdb = rs.body

        this.check_mmdb_available()

      } catch (e) { console.log(e); this.$toastr.e(`${_i18n_data._i18n_error.mmdb_version[this.i18n]}`) }

    },

    // CRS 새로고침(차트 포함)
    refresh_custom_crs() {
      this.info.chart.policy.series = []
      this.now_policy.custom_crs_dic = Object.assign({})

      // 정책 분포 차트
      this.info.chart.policy.option.labels = _.map(codes.WAF_MODE, x => codes.WAF_MODE_I18N(x, this.i18n || 'EN'))

      this.info.chart.policy.series = [0, 0, 0]

      console.log('this.info.chart.policy.option.labels', this.info.chart.policy.option)

      for (let l = 0; l < this.now_policy.custom_crs.length; l++) {

        if(!this.now_policy.custom_crs[l].is_available) { continue }

        // is_toggle 업데이트
        this.now_policy.custom_crs[l].is_toggle_status_origin = this.now_policy.custom_crs[l].is_toggle_status
        this.now_policy.custom_crs_dic[this.now_policy.custom_crs[l].key] = this.now_policy.custom_crs[l]

        // 제외 정책
        if(this.now_policy.custom_crs[l].key.startsWith('903.')) {
          // this.info.chart.policy.series[0] += this.now_policy.custom_crs[l].policy_list.length
          continue
        }

        _.forEach(this.now_policy.custom_crs[l].policy_list, p => {

          if(!p.is_available) { return }
          if(p.level > 1) { return }

          if(codes.WAF_MODE_I18N(p.mode) == 'Off') { this.info.chart.policy.series[0] += 1 }
          else if(codes.WAF_MODE_I18N(p.mode) == 'DetectionOnly') { this.info.chart.policy.series[1] += 1 }
          else { this.info.chart.policy.series[2] += 1 }
        })
      }
    },

    async reload(agent) {

      this.loading = true

      this.server = Object.assign({ iwaf_type : '' }, agent, { policy_json : JSON.parse(agent.policy), lock : false });
      this.server.iwaf_type = (this.server.iwaf_type).trim()
      this.agent_setting = Object.assign({}, this.setting, this.server.setting ? JSON.parse(this.server.setting) : {})

      // 기본 정책 로딩
      // let rs_crs = await api.webcastle.WebCastle({ target : 'policy', cmd : 'detail', body : { id : this.server.crs_id } });
      let rs_crs = await wc.policy.detail({ id : this.server.crs_id });
      if(rs_crs.error) { return this.$toastr.e(`${i18n_data._i18n_error.policy_failed[this.i18n]}`) }
      // console.log('rs_crs.body', rs_crs.body)

      this.crs_rule = Object.assign({}, this.crs_rule, { id : rs_crs.body.id, version : rs_crs.body.version })

      // 메모리 줄이기, 불필요 삭제
      delete rs_crs.body.crs_rule
      delete rs_crs.body.crs_json


      // TODO : 버전에 따른 정책 업데이트 구현 필요
      let select_policy = this.crs_version_list[_.findIndex(this.crs_version_list, x => x.id == this.crs_rule.id)]
      if(select_policy > -1) { this.crs_rule = this.target_crs_rule = select_policy }

      Object.keys(this.base_policy).forEach(k => this.base_policy[k] = [])
      // 정책 구분
      for (let x = 0; x < rs_crs.body.policy.policy.length; x++) {
        let main = rs_crs.body.policy.policy[x];
        // console.log('main', main)
        if(main.i18n['EN'].keyword.indexOf('EXCLUSION') > -1) { this.base_policy.exclusion.push(main); continue; }
        else if(main.i18n['EN'].keyword.indexOf('APPLICATION') > -1) { this.base_policy.process.push(main); continue; }
        else if(main.i18n['EN'].keyword.indexOf('REQUEST') > -1) { this.base_policy.request.push(main); continue; }
        else { this.base_policy.response.push(main); continue; }
      }

      this.default_policy_crs = rs_crs.body.policy.policy

      this.reload_custom()

      this.loading = false

      this.check_change()

      this.refresh_custom_crs()

      this.get_policy_summary()
    },

    // initialize
    async get({ id } = this.$route.params) {
      try {
        // let id = this.$route.params.id


        // let rs = await api.webcastle.WebCastle({ target : 'agent', cmd: 'detail', body: { id : id }})
        let rs = await wc.agent.detail({ id : id })
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.agent_failed[this.i18n]}`) }

        // input is agent
        await this.reload(rs.body)

        this.is_require_save = false
        // this.server.lock = true

        // 최근 배포 정책 로딩
        this.get_policy_version()
        this.get_mmdb_version()
        this.ping()


        // TODO : 향후 레벨 내용 사용시 활용 차트
        // 시작
        // this.summary.level.chart = {
        //   labels: [],
        //   datasets:
        //   [
        //     { label: this.codes.WAF_MODE_I18N('0', this.i18n || 'EN'), data: [], backgroundColor: codes.WAF_MODE_TO_COLOR(1), },
        //     { label: this.codes.WAF_MODE_I18N('1', this.i18n || 'EN'), data: [], backgroundColor: codes.WAF_MODE_TO_COLOR(2), },
        //     { label: this.codes.WAF_MODE_I18N('2', this.i18n || 'EN'), data: [], backgroundColor: codes.WAF_MODE_TO_COLOR(3), },
        //   ]
        // }

        // _.forEach(codes.WAF_LEVEL, x => {
        //   this.summary.level.chart.labels.push(`레벨 ${x}`)
        //   console.log('this.summary.level[x].off', this.summary.level[x].off)
        //   this.summary.level.chart.datasets[0].data.push(this.summary.level[x].off)
        //   this.summary.level.chart.datasets[1].data.push(this.summary.level[x].detect)
        //   this.summary.level.chart.datasets[2].data.push(this.summary.level[x].block)
        // }),

        // 정책 생성 시작
        // 에이전트 정책 로딩, 처음 기본값 도메인은 default
        let index = _.findIndex(this.server.policy_json.domains, { domain : this.now_policy.domain } )
        if(index < 0) { return alert(_i18n_data._i18n_alert.domain_check_3[this.i18n]) }

        // console.log('WTF', JSON.parse(JSON.stringify(this.server.policy_json.domains[index])))

        this.now_policy = Object.assign({}, this.now_policy, default_policy(), JSON.parse(JSON.stringify(this.server.policy_json.domains[index])))
        // console.log('policy', this.now_policy)

        this.now_policy.custom_crs_dic = {}

        // TODO : 사용자 정책 설정 필요

        this.refresh_custom_crs()

        // 백엔드 null 대응
        let p = JSON.parse(this.server.policy)
        p.ip_list = p.ip_list == null ? [] : _.map(p.ip_list, x => { x.mode_origin = x.mode; x.is_change = false; return x })
        p.host_list = p.host_list == null ? [] : _.map(p.host_list, x => { x.mode_origin = x.mode; x.is_change = false; return x })
        p.parameter = p.parameter == null ? [] : _.map(p.parameter, x => { x.mode_origin = x.mode; x.is_change = false; return x })
        p.path = p.path == null ? [] :  _.map(p.path, x => { x.mode_origin = x.mode; x.is_change = false; return x })
        p.country_code = p.country_code == null ? [] : _.map(p.country_code, x => { x.mode_origin = x.mode; x.is_change = false; return x })
        // p.method_control = p.method_control == null ? [] _.map(p.ip_list, x => { x.mode_origin = x.mode; x.is_change = false; return x })
        this.server.policy = JSON.stringify(p)

        // GEO 정책 업데이트
        this.now_policy.use_geoip_origin = this.now_policy.use_geoip;

        // 사용자 CRS 정책
        this.custom_policy = this.now_policy.custom_policy ? this.base64decode(this.now_policy.custom_policy) : ''
        // 에이전트 설정
        this.agent_setting = Object.assign({}, this.agent_setting, JSON.parse(this.server.setting))

        // 리다이렉션 처리
        this.now_policy.redirection_origin = this.now_policy.redirection;

        // 제한 처리
        this.now_policy.limit_origin = JSON.parse(JSON.stringify(this.now_policy.limit));

        if(this.server.updated_at == this.server.created_at) { this.quick_setting_status = true; this.is_first = true }

        this.loading = false

        this.$toastr.i(`${i18n_data._i18n_info.load_success[this.i18n]}`);

        return
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, `${i18n_data._i18n_error.error_code[this.i18n]}`); }
    },

    // 실시간 자원 모니터링, status 로 핑 대체할 수 있음
    res(m) {
      if(m.agent_id != this.server.id) { return;  }
      switch (m.cmd) {
        case "pong":
          this.info = Object.assign({}, this.info, { ms : Math.abs(new Date().getTime() - m.body), is_online : true })
          this.$forceUpdate()
          // console.log('ms', this.info.ms, this.info.is_online)
          break;

        case "status":
          this.wait_resource = false
          this.info = Object.assign({}, this.info, { status : m.body })
          this.info.status.system_cpu_info =  this.info.status.system_cpu_info && typeof this.info.status.system_cpu_info == typeof '' ? JSON.parse(this.info.status.system_cpu_info) : this.info.status.system_cpu_info
          this.info.status.system_disk_info = this.info.status.system_disk_info && typeof this.info.status.system_disk_info == typeof '' ? JSON.parse(this.info.status.system_disk_info) : this.info.status.system_disk_info
          this.info.status.system_memory_info = this.info.status.system_memory_info && typeof this.info.status.system_memory_info == typeof '' ? JSON.parse(this.info.status.system_memory_info) : this.info.status.system_memory_info

          // add chart data
          this.info.status.system_memory_info = this.info.status && this.info.status.system_memory_info && typeof '' == typeof this.info.status.system_memory_info ? JSON.parse(this.info.status.system_memory_info) : this.info.status.system_memory_info
          if(this.info.status.system_memory_info) {
            let value = this.info.status.system_memory_info
            if(this.info.status.system_memory_info.usedPercent) {
              value = this.info.status.system_memory_info.usedPercent
            }

            value = Number(value.toFixed(1))

            if(this.info.chart.memory.series.length < 1) {
              this.info.chart.memory.series = []
              this.info.chart.memory.series.push({
                name : '', data : []
              })
            }

            if(this.info.chart.memory.series[this.info.chart.memory.series.length -1].data.length >= 8) {
              this.info.chart.memory.series[this.info.chart.memory.series.length -1].data.shift()
              this.info.chart.memory.xaxis.categories.shift()
            }

            this.info.chart.memory.series[this.info.chart.memory.series.length - 1].data.push(value)
            this.info.chart.memory.xaxis.categories.push(moment().format('mm:ss'))

            if(value > 33) {
              this.info.chart.memory.colors[this.info.chart.memory.colors.length - 1] = this.info.chart.color.WARNING
              if(value > 66) {
                this.info.chart.memory.colors[this.info.chart.memory.colors.length - 1] = this.info.chart.color.DANGER
              }
            } else {
              this.info.chart.memory.colors[this.info.chart.memory.colors.length - 1] = this.info.chart.color.NORMAL
            }

            this.$refs._chart_memory && this.$refs._chart_memory.updateSeries(this.info.chart.memory.series)

          }

          this.info.status.system_cpu_info = this.info.status && this.info.status.system_cpu_info && typeof '' == typeof this.info.status.system_cpu_info ? JSON.parse(this.info.status.system_cpu_info) : this.info.status.system_cpu_info


          if(this.info.status && this.info.status.system_cpu_info.info && this.info.status.system_cpu_info.info.length > 0 && !this.info.status.system_cpu_name) {
            try {
              this.info.status.system_cpu_info.info = JSON.parse(this.info.status.system_cpu_info.info)
            } catch (e) {
              // console.log(e)
            }

            if(typeof this.info.status.system_cpu_info.info == typeof '') {
              // 개선
              this.info.status.system_cpu_name = this.info.status.system_cpu_info.info
            } else {
              // 하위 호환
              this.info.status.system_cpu_name = this.info.status.system_cpu_info.info[0].modelName
            }

            this.info.chart.workload.title = {
              text: this.info.status.system_cpu_name + ' WorkLoad',
              align: 'left',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize:  '14px',
                fontWeight:  'bold',
                // fontFamily:  undefined,
                color:  '#263238'
              },
            }
          } else if(this.server.cpu_info) {
            this.info.chart.workload.title = {
              text: this.server.cpu_info + ' WorkLoad',
              align: 'left',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize:  '14px',
                fontWeight:  'bold',
                // fontFamily:  undefined,
                color:  '#263238'
              },
            }
          }

          if(this.info.status.system_cpu_info != undefined && this.info.status.system_cpu_info.usage != undefined) {

            if(this.info.chart.cpu.series.length < 1) {
              this.info.chart.cpu.series = []
              this.info.chart.cpu.series.push({
                name : '', data : []
              })
            }
            if(this.info.chart.cpu.series[this.info.chart.cpu.series.length - 1].data.length >= 8) {
              this.info.chart.cpu.series[this.info.chart.cpu.series.length - 1].data.shift()
              this.info.chart.cpu.xaxis.categories.shift()
            }
            this.info.chart.cpu.series[this.info.chart.cpu.series.length - 1].data.push(this.info.status.system_cpu_info.usage)
            this.info.chart.cpu.xaxis.categories.push(moment().format('mm:ss'))

            // cpu 데이터가 있을 경우
            // console.log('this.info.status.system_cpu_info.usages', this.info.status.system_cpu_info.usages)

            if(this.info.status.system_cpu_info.usages  != undefined) {
              this.info.status.system_cpu_info.usages = _.map(this.info.status.system_cpu_info.usages, x => Number(x.toFixed(1)))

              // this.info.status.system_cpu_info.usage = (_.sum(this.info.status.system_cpu_info.usages, x => Number(x)) / this.info.status.system_cpu_info.usages.length).toFixed(1)

              if(Number(this.info.status.system_cpu_info.usage) > 33) {
                this.info.chart.cpu.colors[0] = this.info.chart.color.WARNING
                if(Number(this.info.status.system_cpu_info.usage) > 66) {
                  this.info.chart.cpu.colors[0] = this.info.chart.color.DANGER
                }
              } else {
                this.info.chart.cpu.colors[0] = this.info.chart.color.NORMAL
              }

              // heatmap chart 시작
              if(this.info.chart.workload.series.length < 1) {
                this.info.chart.workload.series = []
                this.info.chart.workload.series.push({ name : 'Thread', data : [], categories : [] })
              }

              this.info.chart.workload.series[this.info.chart.workload.series.length - 1].data = this.info.status.system_cpu_info.usages

              if(this.$refs._chart_workload) {
                // refresh
                console.log('reload workload')
                this.$refs._chart_workload.updateSeries(this.info.chart.workload.series)
              }
            }

            // cpu 차트 컬러 조정
            if(Number(this.info.status.system_cpu_info.usage) > 33) {
              this.info.chart.cpu.colors[0] = this.info.chart.color.WARNING
              if(Number(this.info.status.system_cpu_info.usage) > 66) {
                this.info.chart.cpu.colors[0] = this.info.chart.color.DANGER
              }
            } else {
              this.info.chart.cpu.colors[0] = this.info.chart.color.NORMAL
            }

            this.$refs._chart_cpu && this.$refs._chart_cpu.updateSeries(this.info.chart.cpu.series)
          }

          break;
        case "setting.test":
          this.server.lock = false
          this.webcastle_alert = true
          this.webcastle_alert_is_error = false
          this.webcastle_alert_msg = m.body.setting_test_info

          // this.webcastle_alert_msg = 'error'
          this.webcastle_alert_is_error = this.webcastle_alert_msg.toLowerCase().indexOf('error') > -1
          console.log("webcastle running", m.body.running, m.body.setting_test_info, 'isError', this.webcastle_alert_is_error)
          break;
        default:
          break;
      }

    },

    // 상태 및 ping 요청
    async ping() {
      try {
        if(this.ping_th) { clearTimeout(this.ping_th); }
        if(!this.server || !this.server.id) { return }

        // 최초 1회 핑퐁 성공시 저장 가능
        if(!this.info.is_online) {
          this.server.lock = false
        }

        // console.log('this.toggle.chart', this.toggle.chart )

        agent.Cmd("ping", this.server.id).then(x => this.res(x))
        this.toggle.chart ? agent.Cmd("status", this.server.id).then(x => this.res(x)) : ''
        this.ping_th = setTimeout(this.ping, 3000)
      } catch(e) { console.log('ping', e)}
    },

    // 에이전트 삭제
    async remove() {
      try {

        this.del_nickname = this.del_nickname.trim()
        if(this.server.nickname != this.del_nickname) { return this.$toastr.e(`${i18n_data._i18n_error.servername_check[this.i18n]}`);  }
        // let rs = await api.webcastle.WebCastle_Call('agent', 'delete', { id : this.server.id })
        let rs = await wc.agent.delete({ id : this.server.id })
        if(rs.error) {  return this.$toastr.e(`${i18n_data._i18n_error.remove_failed[this.i18n]}`) }

        this.del_nickname = '';
        this.toggle.modal_del = false;

        this.$toastr.e(`${i18n_data._i18n_error.remove_failed[this.i18n]}`);

        return this.list()
      } catch (e) {
        this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText)
      }
    },
  },
  watch: {
    '$route' (to, from) { console.log("from ", from); this.get(to.params.id); },
  },
  created() {
    console.log('agent.detail.vue', 'created');

  },
  destroyed() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    console.log('agent.detail.vue', 'destroyed');
  },
  mounted() {
    console.log('agent.detail.vue', 'mounted');
    // 개선해야 하는 부분, 한번에 요청 방지
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    this.get()
    signalr.subscribe('webcastle_response', this.res)
    if(sessionStorage.getItem('crs_count_preview') != undefined) {
      this.crs_count_preview = sessionStorage.getItem('crs_count_preview') == 'true'
    }
  },
}
